import { Row } from "react-bootstrap";
import { Typography } from "../../components/utilities/Typhograpy";
import { useContext, useEffect, useRef, useState } from "react";
import { GetNotificatinDetail } from "../../api/NotificationApi";
import GlobalContext from "../../context/GlobalContext";
import swal from "../../services/swalConfig";
import BoxSkeleton from "../../components/utilities/BoxSkeleton";
import { RunFunction } from "../../services/CallFunction";

import { tr } from "../../i18n";
const InboxDetailPage = ({ idInbox }) => {
  const [detailInbox, setDetailInbox] = useState(null);
  const [processedMessage, setProcessedMessage] = useState("");
  const { user, setLoading } = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(true);

  const getProcessedMessage = (action, processedAction = null) => {
    const finalAction = processedAction || action;

    if (finalAction === "Approved") {
      return "You have already approved this request.";
    }

    if (finalAction === "Decline") {
      return "You have already declined this request.";
    }

    return "This request has already been processed.";
  };

  const isAlreadyProcessedResponse = (result) => {
    const message = (result?.message || "").toLowerCase();

    return result?.status === 404 && message.includes("already processed");
  };

  const LoadDetailNotification = async () => {
    try {
      setIsLoading(true);

      const result = await GetNotificatinDetail({
        notification_id: idInbox,
        company_id: user.workspace.company_id,
      });

      if (result.status == 200) {
        setDetailInbox(result.data);
        if (result.data?.is_buttons_active !== "Active") {
          setProcessedMessage(
            getProcessedMessage(null, result.data?.processed_action),
          );
        }
        setIsLoading(false);
      }
    } catch (error) {
      swal.fire({
        title: tr("common:errors.oops"),
        text: tr("inbox:something_wrong_try_again_later"),
        icon: "error",
        showCancelButton: false,
      });
    }
  };

  useEffect(() => {
    setDetailInbox(null);
    setProcessedMessage("");
    if (idInbox) {
      LoadDetailNotification();
    }
  }, [idInbox]);

  const handleOnClick = async (functionName, params) => {
    setLoading(true);

    try {
      const result = await RunFunction(functionName, params);

      if (result.status == 200) {
        const statusMessage = getProcessedMessage(params?.action);
        setProcessedMessage(statusMessage);
        setDetailInbox((prev) =>
          prev
            ? {
                ...prev,
                is_buttons_active: "Disabled",
              }
            : prev,
        );

        swal.fire({
          title: tr("inbox:succcess"),
          text: result.message,
          icon: "success",
          showCancelButton: false,
        });
      } else if (isAlreadyProcessedResponse(result)) {
        const statusMessage = getProcessedMessage(params?.action);
        setProcessedMessage(statusMessage);
        setDetailInbox((prev) =>
          prev
            ? {
                ...prev,
                is_buttons_active: "Disabled",
              }
            : prev,
        );

        swal.fire({
          title: tr("inbox:info"),
          text: result.message,
          icon: "info",
          showCancelButton: false,
        });
      } else {
        swal.fire({
          title: tr("common:errors.oops"),
          text: result.message,
          icon: "error",
          showCancelButton: false,
        });
      }
    } catch (error) {
      swal.fire({
        title: tr("common:errors.oops"),
        text: tr("inbox:something_wrong_try_again_later"),
        icon: "error",
        showCancelButton: false,
      });
    } finally {
      setLoading(false);
      LoadDetailNotification();
    }
  };

  return idInbox ? (
    <div className="inbox-detail-wrapper">
      <div className="inbox-detail-header">
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="inbox-detail-header-icon"
        >
          <rect x="2" y="4" width="20" height="16" rx="2" />
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
        <Typography variant="h6" style={{ fontWeight: 700, color: "white" }}>
          {tr("inbox:notification_details")}
        </Typography>
      </div>
      <div className="inbox-detail-container">
        <Row>
          {isLoading || !detailInbox ? (
            <div className="col-12">
              <BoxSkeleton count="1" size="12" height="50px"></BoxSkeleton>
              <BoxSkeleton count="10" size="12" height="15px"></BoxSkeleton>
            </div>
          ) : (
            <>
              <div className="col-12">
                <div className="inbox-detail-subject">
                  <Typography variant="h6">
                    <b style={{ fontWeight: 700, color: "#2c3e50" }}>
                      {detailInbox.notification_subject}
                    </b>
                  </Typography>
                </div>
              </div>
              <div className="col-12">
                <div className="inbox-detail-body">
                  <Typography
                    variant="body1"
                    style={{
                      whiteSpace: "pre-wrap",
                      color: "#34495e",
                      lineHeight: "1.6",
                    }}
                  >
                    {detailInbox.notification_content}
                  </Typography>
                </div>

                {detailInbox.buttons_content &&
                detailInbox.is_buttons_active === "Active" ? (
                  <Row className="inbox-detail-actions mt-4">
                    {detailInbox.buttons_content.map((data, index) => (
                      <div className="col-6" key={index}>
                        <button
                          className="inbox-action-btn"
                          onClick={() =>
                            handleOnClick(data.function, data.params)
                          }
                          style={{
                            backgroundColor: data.backgroundColor,
                            color: "white",
                          }}
                        >
                          {data.text}
                        </button>
                      </div>
                    ))}
                  </Row>
                ) : detailInbox.buttons_content ? (
                  <div className="mt-3">
                    <Typography variant="body2" style={{ color: "#4b5563" }}>
                      {processedMessage ||
                        tr("inbox:this_request_has_already_been_processed")}
                    </Typography>
                  </div>
                ) : null}
              </div>
            </>
          )}
        </Row>
      </div>
    </div>
  ) : (
    <div className="inbox-detail-empty">
      <svg
        width="56"
        height="56"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="inbox-empty-detail-icon"
      >
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
      </svg>
      <Typography
        variant="body1"
        style={{ fontWeight: 500, color: "#7f8c8d", marginTop: "16px" }}
      >
        {tr("inbox:select_a_notification_to_view_details")}
      </Typography>
    </div>
  );
};

export default InboxDetailPage;
